<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <input
      :id="id"
      :data-test-id="`input-${id}`"
      :value="valor"
      :name="id"
      :placeholder="label"
      :readonly="somenteLeitura"
      type="text"
      class="form-control"
      @input="atualizar($event.target)"
    />
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'

export default {
  name: 'CampoNome',
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: 'Nome',
    },
    id: {
      type: String,
      default: 'nome',
    },
  },
}
</script>
